// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__YYhjs","label":"LabeledBox_label__21noL"};